const State = {
  uploadUrl: '',
  csvUploadTotal: '',
  csvUploadErrorList: [],
  csvUploadHistoryList: []
}

export default State
